import { apiGet, apiPatch, apiPost } from "./api";

export async function submitContactForm(payload) {
  return apiPost("/contacts/messages/create/", payload);
}

export async function submitConsultationForm(payload) {
  return apiPost("/contacts/leads/create/", payload);
}

export async function getAdminMessages(params = {}) {
  return apiGet("/contacts/messages/", params);
}

export async function updateMessageStatus(messageId, payload) {
  return apiPatch(`/contacts/messages/${messageId}/status/`, payload);
}

export async function getAdminLeads(params = {}) {
  return apiGet("/contacts/leads/", params);
}

export async function updateLeadStatus(leadId, payload) {
  return apiPatch(`/contacts/leads/${leadId}/status/`, payload);
}


export async function getContactMessages(params = {}) {
  return getAdminMessages(params);
}

export async function updateContactMessageStatus(messageId, payload) {
  return updateMessageStatus(messageId, payload);
}
